module.exports = __webpack_public_path__ + "5d8808d43cefca6f6781a5316d176632.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/ui/images/ui-icons_cd0a0a_256x240.png
// module id = 237
// module chunks = 0